import i18n from '@dms/i18n';

import {useVehicleFormContext} from '../hooks/useVehicleFormContext';
import {Field} from './primitives/Field';

export function InteriorMaterialChips() {
  const {catalogueApi} = useVehicleFormContext();
  return (
    <Field
      type="chips"
      name="interiorMaterial"
      label={i18n.t('entity.vehicle.labels.interiorMaterial')}
      options={catalogueApi?.interiorMaterialOptions ?? []}
      isDeselectable
    />
  );
}
